import { Container } from './styles';
import Title from '../common/Title';
import Tabs from '../common/TabSwich/Tabs'
import { configFile } from './constants';

const ScoringPrograms = () => {

    return (
        <Container>
            <Title>Asignación de programas y recompensas </Title>
            <p><b>Objetivo: </b>Asegurar que el inventario directo sea visible y pueda recibir 30% del total de leads que generamos.</p>
            <Tabs configFile={configFile}></Tabs>
        </Container >
    );
};

export default ScoringPrograms;
